import uiCianButtonTemplate from './Button.jade';
import './Button.styl';
const uiCianButtonTemplateName = 'ui-cian-button-template.html';

export const Button = angular
  .module('ui.cian.button', [])
  .directive('cianUiButton', [
    () => ({
      scope: {},
      bindToController: {
        state: '@', // active
        look: '@', // solid, gray
        size: '@?', // m
        buttonType: '@?',
        isHovered: '@?',
      },
      link(scope, elem, attrs, ctrl) {
        elem.attr('type', ctrl.buttonType);
      },
      controller() {
        this.tmpl = this.template || this.templateUrl;
        this.buttonType = this.buttonType || 'button';

        this.isButtonActive = () => this.state === 'active';
        this.isButtonDisabled = () => this.state === 'disabled';
        this.isButtonHovered = () => this.isHovered === 'true';
      },
      controllerAs: 'button',
      transclude: true,
      replace: true,
      templateUrl(elem, attr) {
        let templateName = uiCianButtonTemplateName;
        if (attr && attr.hasOwnProperty('btnTemplate')) {
          templateName = attr.btnTemplate;
        }

        return templateName;
      },
    }),
  ])
  .run([
    '$templateCache',
    $templateCache => {
      $templateCache.put(uiCianButtonTemplateName, uiCianButtonTemplate);
    },
  ]).name;
